import { Pipe, PipeTransform } from '@angular/core';
import { RelatedToType } from 'app/shared/enums';
import { Store } from '@ngxs/store';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { FieldDef } from '@core/models';

@Pipe({ name: 'fieldDef', standalone: true })
export class FieldDefPipe implements PipeTransform {
  constructor(private readonly store: Store) {}

  transform(fieldName: string, relatedTo: RelatedToType | string): FieldDef {
    return this.store
      .selectSnapshot(ObjectsManagerState.getFieldsByObjectName(relatedTo))
      .find((field) => field.name === fieldName);
  }
}
